wbApp.directive('wbAcceptCompensationsFromEdit', ['compensationGroupSvc',
    function (compensationGroupSvc) {

        return {
            restrict: 'A',
            require: 'ngModel',
            template: '<div class="row">' +
                      '    <div ng-repeat="compGrp in compensationGroups" class="col-xs-4">' +
                      '        <input wb-checkbox-edit' + 
                      '               class="form-control"' +
                      '               ng-model="compGrp.included">' +
                      '        <label class="control-label" ng-class="{\'text-muted\' : compGrp.isDeleted}" >&nbsp;' +
                      '            <s ng-show="!compGrp.active || compGrp.isDeleted">{{compGrp.name}}</s>' +
                      '            <span ng-hide="!compGrp.active || compGrp.isDeleted">{{compGrp.name}}</span>' +
                      '        </label>' +
                      '    </div>' +
                      '</div>',
            replace: true,
            link: function (scope, elm, attrs, ctrl) {
                var compensationGroupsRaw = compensationGroupSvc.getLookupActiveAsync(ctrl.$viewValue);
                var initialized = false;

               scope.compensationGroups = [];

               ctrl.$render = function () {

                   if (!initialized) {
                       compensationGroupsRaw = compensationGroupSvc.getLookupActiveAsync(ctrl.$viewValue);
                   }

                   compensationGroupsRaw.$promise.then(function () {

                        var lookup = ctrl.$viewValue;

                        var models = _.map(compensationGroupsRaw, function (cg) {
                            return {
                                id: cg.id,
                                name: cg.name,
                                active: cg.active,
                                isDeleted: cg.isDeleted,
                                included: _.indexOf(lookup, cg.id) !== -1
                            };
                        });

                        initialized = true;
                        scope.compensationGroups.length = 0;
                        scope.compensationGroups.push.apply(scope.compensationGroups, models);

                    });
               };

               scope.$watch('compensationGroups', function (newValue) {
                   if (!initialized) {
                       return;
                   }

                   var included = _.filter(newValue, { included: true });
                   var newViewValue = _.map(included, function (i) {
                       return i.id;
                   })

                   ctrl.$setViewValue(newViewValue);
               }, true);
            }
        }
    }]);


//<div class="row">
//    <div ng-repeat="compGrp in compensationGroups" class="col-xs-4">
            
//            <input wb-checkbox-edit
//                   class="form-control"
//                   ng-model="compGrp.include">
//            <label class="control-label">&nbsp;{{compGrp.name}}</label>
            
//    </div>
//</div>